import type * as React from 'react';

import type { MarkProps } from '@gitbook/slate-react';

export function MarkStrikethrough(props: MarkProps): React.ReactElement {
    const { children, attributes } = props;

    return (
        <span className="line-through" {...attributes}>
            {children}
        </span>
    );
}
